import BaseProxy from "../../base-proxy";
import LocalStoreManager from "@/utilities/local-store-manager";


/**
 * @class GetPlatformConfig
 * @description Class used for listing application features.
 * @author Kelvin John Santos
 * @version 1.0
 * @since August 22, 2019
 */
export default class GetPlatformConfig {
  /**
   * @async
   * @function execute
   * @param input Input parameter.
   * @param {String} input.platform Responding company user's ID.
   * @param {String} input.authToken Token used for issuing authenticated request.
   */
  async getPlatformConfigFromServer(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/config/platform/${input.platform}/`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getAuthenticatedAppFeatures() {
    const localStore = new LocalStoreManager();
    const authToken = localStore.getToken();
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/v2/config/platform/authenticated/`;
    return await baseProxy.getAuthenticatedData(endpointUrl, authToken);
  }
}
